import React, { useEffect } from 'react'
import { useTenant } from '@emerald-works-nova/auth'
import PreviewPaywall from './default'
import PaywallVariant from './variant'
import { useGroup, useABTestLogger } from '../../../hooks'
import { BROWSER } from '../../../services/cognito/userGroups'

export const PAYWALL_VARIANT_STORAGE_KEY = 'paywall-variant'
export const PAYWALL_VARIANTS = {
  default: 'DEFAULT',
  variant: 'VARIANT'
}

const Paywall = () => {
  const tenant = useTenant()
  const { sendABTestLog } = useABTestLogger()
  const paywallTestOn = tenant.paywallTestOn || false
  const { isInGroup } = useGroup()
  const isBrowserUser = isInGroup(BROWSER)
  const storedVariant = localStorage.getItem(PAYWALL_VARIANT_STORAGE_KEY)

  const shouldDisplayPaywallVariant =
    isBrowserUser && paywallTestOn && storedVariant &&
    storedVariant === PAYWALL_VARIANTS.variant

  useEffect(() => {
    if (!storedVariant && paywallTestOn && isBrowserUser) {
      console.log('[PAYWALL] No stored variant found, selecting a random one.')
      // If no stored variant, select a random one from the fallback variants
      // Since we have only two variants, we can use a simple random selection
      // 0 - DEFAULT, 1 - VARIANT
      const randomNumber = Math.floor(Math.random() * 2)
      const selectedVariant = randomNumber === 0 ? PAYWALL_VARIANTS.default : PAYWALL_VARIANTS.variant
      localStorage.setItem(PAYWALL_VARIANT_STORAGE_KEY, selectedVariant)
      console.log(`[PAYWALL] Selected variant: ${selectedVariant}`)
      sendABTestLog({
        experimentName: 'paywall',
        experimentVariant: selectedVariant,
        experimentAction: 'page_view'
      })
      console.log('[PAYWALL] (Init) AB test log sent. Variant:', selectedVariant)
      return
    }

    if (paywallTestOn && isBrowserUser) {
      sendABTestLog({
        experimentName: 'paywall',
        experimentVariant: storedVariant,
        experimentAction: 'page_view'
      })
      console.log('[PAYWALL] AB Test Page Land log sent. Variant:', storedVariant)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {shouldDisplayPaywallVariant ? <PaywallVariant /> : <PreviewPaywall />}
    </>
  )
}

export default Paywall
